module.exports = require('./helpers/bundle-url').getBundleURL('f0Cf5') + "logo.c51670a8.svg";